class LanguageSelector {
	domRoot: HTMLElement;
	selectElement: HTMLSelectElement;

	constructor(domRoot: HTMLElement) {
		this.domRoot = domRoot;
		this.selectElement = domRoot.querySelector("select") as HTMLSelectElement;
		this.init();
	}

	init(){
		this.selectElement?.addEventListener("change", (e) => {
			this.selectElement.style.width = `${e.target.selectedOptions[0].dataset.width}`;

			// Set cookie so the server can redirect to localized site of user's choice
			document.cookie = "user_select_lang=" + e.target.selectedOptions[0].dataset.lang + "; max-age=31536000; path=/; domain=atlassian.com;";
			window.location = e.target.value;
		});
	}
}

export default LanguageSelector;